import { useContext } from 'react';
import { matchPath } from 'react-router-dom';
import { AppContext } from 'src/context';
import { getBaseUrl } from 'src/utils/getConfig';
import { redirectUrlsMap } from 'src/utils/capabilities';
import { evaluateConditions } from './conditions';

export const useRedirect = to => {
  const { store } = useContext(AppContext);
  const selfUrl = getBaseUrl();
  const redirectChain = redirectUrlsMap.find(url =>
    matchPath(to, { path: url.from, exact: true }),
  );
  const conditionsMatched = evaluateConditions(
    store,
    redirectChain?.conditions || [],
  );
  if (redirectChain && conditionsMatched)
    return `${selfUrl}${redirectChain.to || to}`;
  return null;
};
